/**
 * @generated SignedSource<<ad67090e33c39d3f12e72209e67c888f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavBarUserMenu_query$data = {
  readonly platform: {
    readonly " $fragmentSpreads": FragmentRefs<"AppVersion_version">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"PreferencesDialog_query">;
  readonly " $fragmentType": "NavBarUserMenu_query";
};
export type NavBarUserMenu_query$key = {
  readonly " $data"?: NavBarUserMenu_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavBarUserMenu_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavBarUserMenu_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Platform",
      "kind": "LinkedField",
      "name": "platform",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AppVersion_version"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreferencesDialog_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "587a7f26d1ac9afaf34caf87a58139c5";

export default node;
